import { loadStripe } from '@stripe/stripe-js';

const style = {
    base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
            color: '#aab7c4'
        }
    },
    invalid: {
        color: 'red',
        iconColor: 'red'
    }
};

async function initStripeForm(publishableKey, paymentSecret) {
    const stripe = await loadStripe(publishableKey);
    const elements = stripe.elements();
    const card = elements.create('card', { style: style });
    const cardHolderName = document.getElementById('card-holder-name')
    const cardBtn = document.getElementById('card-button')
    const cardErrors = document.getElementById('card-errors')

    card.mount('#card-element');

    card.on('change', function(event) {
        let displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    // Handle form submission.
    const form = document.getElementById('payment-form');

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const { setupIntent, error } = await stripe.confirmCardSetup(
            paymentSecret, {
                payment_method: {
                    card: card,
                    billing_details: {
                        name: cardHolderName.value
                    }
                }
            }
        )

        if(error) {
            cardBtn.disable = false
            console.log(error)
            cardErrors.innerHTML = error.message
        } else {
            let token = document.createElement('input')

            token.setAttribute('type', 'hidden')
            token.setAttribute('name', 'order[token]')
            token.setAttribute('value', setupIntent.payment_method)

            form.appendChild(token)

            form.submit();
        }
    });

}

async function initPaymentIntentForm(publishableKey, paymentIntent, orderId) {
  const stripe = await loadStripe(publishableKey);
  const options = {
    clientSecret: paymentIntent,
    // Fully customizable with appearance API.
    // appearance: {/*...*/},
  };

  const elements = stripe.elements(options);

  // Create and mount the Payment Element
  const paymentElement = elements.create('payment');
  paymentElement.mount('#payment-element');


  const form = document.getElementById('process_payment_form');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    // query
    const query = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    let domain = `${document.location.protocol}//${document.location.host}`
    let redirectionUrl =  `${domain}/orders/${orderId}/process_payment`
    if (query._t)
      redirectionUrl += `?_t=${query._t}&embed=1`

    console.log(`Processing payment and redirecting user to: ${redirectionUrl}`)

    const {error} = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: redirectionUrl,
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (e.g., payment
      // details incomplete)
      const messageContainer = document.querySelector('#error-message');
      messageContainer.textContent = error.message;
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  });

}

if (document.getElementById('payment-form') && document.getElementById('payment-form').length) {
    console.log('Initializing stripe payment form')
    let el = document.getElementById('payment-form')
    let publishableKey = el.dataset.publishableKey
    let paymentIntentSecret = el.dataset.paymentSecret
    initStripeForm(publishableKey, paymentIntentSecret);
}

if (document.getElementById('process_payment_form') && document.getElementById('process_payment_form').length) {
  console.log('Initializing stripe payment form')
  console.log(`Found env var ${process.env.STRIPE_PRIVATE_API_KEY}`)
  let el = document.getElementById('process_payment_form')
  let publishableKey = el.dataset.publishableKey
  let paymentIntent = el.dataset.paymentIntent
  let orderId = el.dataset.orderId
  initPaymentIntentForm(publishableKey, paymentIntent, orderId);
}